import {AlertEnum, MessageEnum, StatusType} from './types';

const DEFAULT_ALERT_STORE: StatusType = {
	type: AlertEnum.NONE,
	typeMessage: MessageEnum.SUCCESS,
	status: false,
};

export {DEFAULT_ALERT_STORE};
